<template>
    <div class="login">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <img src="../assets/img/ecdc-logo.svg" alt="ecdc-logo" class="img-fluid logo" />
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-md-4">
                    <label for="username" class="label">USERNAME</label>

                    <input type="text" class="form-control form-field" id="username" v-model="loginData.username" />
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-md-4">
                    <label for="password" class="label">PASSWORD</label>

                    <input type="password" class="form-control form-field" id="password" v-model="loginData.password" />
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-md-4">
                    <button class="btn btn-block btn-ecdc" @click="login()">Login</button>
                </div>
            </div>
        </div>

        <div class="custom-alert alert alert-danger" role="alert" v-if="isError">
            Invalid login details, please check again.
        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { login } from '../api'
import Loader from './Loader.vue'
import { setAuth } from '../helpers'

export default {
    components: {
        appLoader: Loader
    },
    data() {
        return {
            loginData: {
                username: "",
                password: ""
            },
            isLoading: false,
            isError: false
        }
    },
    mounted() {
        
        localStorage.removeItem("jwt");
        localStorage.removeItem("name");
        localStorage.removeItem("area_id");
        localStorage.removeItem("region_id");
        localStorage.removeItem("division");
        localStorage.removeItem("projId");
        localStorage.removeItem("projName");
    },
    methods: {
        async login() {

            const _this = this;
            this.isLoading = true;

            try {
                const data = await login(this.loginData)
                setAuth(data);
                this.$router.push({ name: "projectSelection" });
            }
            catch(err) {

                this.isError = true;
                window.scrollTo(0, 0);

                setTimeout(function() { 
                    
                    _this.isError = false;
                }, 2000);
            }

            this.isLoading = false; 
        }
    }
}
</script>

<style scoped>
.login {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
}

.login .logo {
    margin-bottom: 75px;
}

.login .label {
    margin-bottom: 10px;
}

.login .form-field {
    margin-bottom: 30px;
    text-align: center;
}
</style>